import React from "react";
import { Button, Checkbox, Form, Icon, Input, message } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import AuthActions from "../appRedux/redux/Auth";
import MessageActions from "../appRedux/redux/Messages";

import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;

class SignIn extends React.Component {

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log(values);
      if (!err) {
        this.props.showAuthLoader();
        this.props.userSignIn(values);
      }
    });
  };

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.props.user != null) {
      this.props.history.push('/');
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { showMessage, loader, alertMessage } = this.props;

    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                {/* <img src="https://via.placeholder.com/272x395" alt='Neature'/> */}
              </div>
              <div className="gx-app-logo-wid">
                <h1><IntlMessages id="app.userAuth.login" /></h1>
                <p className="gx-mt-4"><IntlMessages id="app.userAuth.byLoginClient" /></p>
              </div>
              <div className="gx-app-logo">
                <Link to="/signupmayor">
                  <button type="default" className="gx-btn gx-btn-red gx-text-white gx-mt-5">
                    <IntlMessages id="app.userAuth.getAccountMayor" />
                  </button>
                </Link>
              </div>
            </div>
            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0">

                <FormItem>
                  {getFieldDecorator('email', {
                    initialValue: "",
                    rules: [{
                      required: true, type: 'email', message: 'Correo no valido!',
                    }],
                  })(
                    <Input placeholder="Email" />
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    initialValue: "",
                    rules: [{ required: true, message: 'Porfavor ingrese su contraseña!' }],
                  })(
                    <Input type="password" placeholder="Contraseña" />
                  )}
                </FormItem>
                <FormItem>
                  <Link to="/forgotPassword">Olvidaste tu contraseña?</Link>
                </FormItem>
                <FormItem>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    <IntlMessages id="app.userAuth.login" />
                  </Button>
                  <span><IntlMessages id="app.userAuth.or" /></span> <Link to="/signup"><IntlMessages
                    id="app.userAuth.signUpClientButton" /></Link>
                </FormItem>
                {/* <div className="gx-flex-row gx-justify-content-between">
                  <span>o ingresa con Google o Facebook</span>
                  <ul className="gx-social-link">
                    <li>
                      <Icon type="google" onClick={() => {
                        this.props.showAuthLoader();
                        this.props.userGoogleSignIn();
                      }} />
                    </li>
                  </ul>
                </div> */}
              </Form>
            </div>

            {loader ?
              <div className="gx-loader-view">
                <CircularProgress />
              </div> : null}
            {showMessage ?
              message.error(alertMessage.toString()) : null}
          </div>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(SignIn);

const mapStateToProps = ({ auth, user: u }) => {
  return {
    ...auth,
    ...u
  }
};

const mapActionsToProps = () => {
  return {
    ...AuthActions,
  }
}

export default connect(mapStateToProps, mapActionsToProps())(WrappedNormalLoginForm);
